<template lang="pug">
v-flex(xs12)
  v-card.payment-form-card(flat)
    div.pa-4
      div.expande-horizontal.align-center.mb-4
        v-avatar(size="34" color="#eff6ff").mr-3
          v-icon(color="#2563eb") mdi-credit-card-outline
        div
          div.form-title Cartao de credito
          div.form-subtitle Seus dados ficam protegidos durante todo o processo

      v-form(ref="card_form")
        div.expande-horizontal.wrap
          v-flex(xs12).pa-1
            v-text-field(
              dense
              outlined
              class="field-modern"
              label="Nome impresso no cartao"
              v-model="get_checkout.card.name"
              :rules="[v => !!v || 'Campo obrigatorio']"
              prepend-inner-icon="mdi-account-outline"
            )
          v-flex(xs12 md6).pa-1
            v-text-field(
              dense
              outlined
              class="field-modern"
              label="Numero do cartao"
              v-model="get_checkout.card.number"
              :rules="[v => !!v || 'Campo obrigatorio']"
              v-mask="['#### #### #### ####']"
              prepend-inner-icon="mdi-credit-card-scan-outline"
            )
          v-flex(xs12 md3).pa-1
            v-text-field(
              dense
              outlined
              class="field-modern"
              label="Mes"
              v-model="get_checkout.card.expiryMonth"
              :rules="[v => !!v || 'Obrigatorio']"
              v-mask="['##']"
            )
          v-flex(xs12 md3).pa-1
            v-text-field(
              dense
              outlined
              class="field-modern"
              label="Ano"
              v-model="get_checkout.card.expiryYear"
              :rules="[v => !!v || 'Obrigatorio']"
              v-mask="['####']"
            )
          v-flex(xs12 md4).pa-1
            v-text-field(
              dense
              outlined
              class="field-modern"
              label="CVV"
              v-model="get_checkout.card.ccv"
              :rules="[v => !!v || 'Campo obrigatorio']"
              v-mask="['####']"
              prepend-inner-icon="mdi-lock-outline"
            )

      v-btn.payment-btn.fonte.text-none(block large dark @click="submitCard" :color="$theme.secondary")
        | Pagar e concluir cadastro
        v-icon.ml-2(size="18") mdi-arrow-right
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters(["get_checkout"])
  },
  methods: {
    ...mapActions(["checkout"]),
    hasValidPayer() {
      const payer = this.get_checkout.payer || {};
      return Boolean(
        payer.name &&
          payer.email &&
          payer.cpf_cnpj &&
          payer.phone_prefix &&
          payer.phone
      );
    },
    submitCard() {
      if (!this.hasValidPayer()) {
        this.$store.dispatch("createGlobalMessage", {
          timeout: 6000,
          type: "warning",
          message: "Preencha primeiro seus dados pessoais antes de pagar."
        });
        return;
      }

      if (!this.$refs.card_form.validate()) {
        return;
      }

      this.checkout();
    }
  }
};
</script>

<style scoped>
.payment-form-card {
  margin-top: 16px;
  border: 1px solid #e9ecf5;
  border-radius: 14px;
  background: #fff;
}

.form-title {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
}

.form-subtitle {
  font-size: 12px;
  color: #64748b;
}

.field-modern {
  border-radius: 10px;
}

.payment-btn {
  margin-top: 10px;
  border-radius: 12px;
  letter-spacing: 0.2px;
}
</style>
